import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import './Custom-Expiry-Select.scss';

const CustomExpirySelect = (props) => {
  const { item, onExirySelectChange } = props;
  const [expiry, setExiry] = useState({ days: 0, hours: 0, minutes: 0 });

  useEffect(() => {
    if (item && item.value && item.value !== '') {
      const expiryValues = item.value.split(':');
      setExiry({
        days: parseInt(expiryValues[0]),
        hours: parseInt(expiryValues[1]),
        minutes: parseInt(expiryValues[2]),
      });
    }
  }, [item]);

  const handleTextChange = (e, field) => {
    const currExpiry = { ...expiry };
    currExpiry[field] = e.target.value;
    setExiry(currExpiry);

    const currField = { ...item };
    currField.value = currExpiry.days + ':' + currExpiry.hours + ':' + currExpiry.minutes;
    onExirySelectChange(currField);
  };

  return (
    <div className='d-flex custom-expiry-select'>
      <div className='me-2 d-flex flex-column align-items-end'>
        <TextField
          placeholder='00'
          value={expiry.days}
          onChange={(e) => handleTextChange(e, 'days')}
          type={'number'}
          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', min: 0 }}
        />
        <span>Days</span>
      </div>
      <div className='me-2 d-flex flex-column align-items-end'>
        <TextField
          placeholder='00'
          value={expiry.hours}
          onChange={(e) => handleTextChange(e, 'hours')}
          type={'number'}
          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', min: 0 }}
        />
        <span>Hours</span>
      </div>
      <div className='me-2 d-flex flex-column align-items-end'>
        <TextField
          placeholder='00'
          value={expiry.minutes}
          onChange={(e) => handleTextChange(e, 'minutes')}
          type={'number'}
          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', min: 0 }}
        />
        <span>Minutes</span>
      </div>
    </div>
  );
};

export default CustomExpirySelect;
